import { render, staticRenderFns } from "./CO2SummaryHorizontalBarChart.vue?vue&type=template&id=4c02ad96&scoped=true"
import script from "./CO2SummaryHorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./CO2SummaryHorizontalBarChart.vue?vue&type=script&lang=js"
import style0 from "./CO2SummaryHorizontalBarChart.vue?vue&type=style&index=0&id=4c02ad96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c02ad96",
  null
  
)

export default component.exports